(function () {
  var STORAGE_KEY = 'iceco-welcome-popup-seen';

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('.welcome-popup');
    if (!popup) return;

    var closeButton = popup.querySelector('[id^="ModalClose-"]');
    var form = popup.querySelector('form');
    var justSubmitted = popup.querySelector('.welcome-popup__success');
    var alreadySeen = window.localStorage.getItem(STORAGE_KEY);

    if (alreadySeen && !justSubmitted) return;

    var markSeen = function () {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    };

    if (closeButton) closeButton.addEventListener('click', markSeen);
    if (form) form.addEventListener('submit', markSeen);

    customElements.whenDefined('modal-dialog').then(function () {
      if (justSubmitted) {
        popup.show(closeButton);
        return;
      }

      var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
      window.setTimeout(function () {
        popup.show(closeButton);
      }, delay);
    });
  });
})();
